import { TaskAddFormEntity } from 'domains/index';

export const DEFAULT_FORM: TaskAddFormEntity = {
  name: '',
  info: '',
  isImportant: false,
};
